import { useState, useEffect } from "react"
import { useHistory, Link, useParams, useLocation } from 'react-router-dom';
import Api from "../api/api";
import stringHelpers from "../../utilities/stringHelpers";
import arrayUtilities from "../../utilities/arrayUtilities";
import roleUtilities from "../../utilities/roleUtilities";
import { ClientSiteTabbed } from "../allow-list/clientSiteTabbed";
import Loader from "../shared/loader";
import { isDateTimeElapsed, toInputFieldDateTimeString } from "../../utilities/dateUtilities";
import { Modal } from 'react-bootstrap'
import { DisallowedVrmDisplay } from "./disallowedVrmDisplay";
import { ErrorModal } from '../../utilities/errorModal';

export const DisallowedVrmAddEdit = ({ user, organisationId, token }) => {
    const userOrganisation = user.organisations.find(x => x.organisation.id === organisationId);
    const isClientOrClientManager = roleUtilities.isClientOrClientManager(user, organisationId);
    const clientAssignedSiteIds = userOrganisation?.siteIds;

    const history = useHistory();
    const { state } = useLocation();
    const { disallowedVrmId } = useParams()
    const isNew = stringHelpers.isNullOrEmpty(disallowedVrmId)
    const [isLoading, setIsLoading] = useState(false)
    const [loadingVehicleLookup, setLoadingVehicleLookup] = useState(false)
    const [successfulLookupVrm, setSuccessfulLookupVrm] = useState(null)
    const [clients, setClients] = useState(null);
    const [formClientId, setFormClientId] = useState("");
    const [site, setSite] = useState("");
    const [sites, setSites] = useState([]);
    const [disallowedVrm, setDisallowedVrm] = useState(null)
    const [vrm, setVrm] = useState("");
    const [vehicleMake, setVehicleMake] = useState("");
    const [vehicleModel, setVehicleModel] = useState("");
    const [colour, setColour] = useState("");
    const [driverName, setDriverName] = useState("");
    const [driverMobileNumber, setDriverMobileNumber] = useState("");
    const [driverEmailAddress, setDriverEmailAddress] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [reason, setReason] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isInEdit, setIsInEdit] = useState(false);

    const [tabActiveKey, setTabActiveKey] = useState(isClientOrClientManager && !arrayUtilities.isNullOrEmpty(clientAssignedSiteIds) ? "site" : "global");
    const [showDeleteModal, setShowDeleteModal] = useState(false)

    const disallowListUrl = isClientOrClientManager ? "/disallow-list" : `/organisation/${ organisationId }/disallow-list`
    const returnUrl = state?.returnUrl ?? disallowListUrl
    const addNewFormTitle = state?.addNewFormTitle ?? "Add New Disallowed VRM"

    const handleTabChange = (e) => {
        setTabActiveKey(e);
        setSite(null);

        if (e === "client" && isClientOrClientManager && clients.length === 1) {
            setFormClientId(clients[0].id);
        } else {
            setFormClientId("");
        }
    }
    const getClients = () => {
        Api.getClients(
            data => {
                setClients(data)
                if (isClientOrClientManager && !arrayUtilities.isNullOrEmpty(data) && isNew) {
                    setTabActiveKey("client")
                }
            },
            error => console.log(error),
            organisationId,
            token
        )
    }
    const getSites = () => {
        Api.getSites(
            (data) => { setSites(data) },
            (error) => console.log(error),
            organisationId,
            token
        )
    };

    const vehicleLookup = () => {
        setLoadingVehicleLookup(true)
        Api.vehicleLookup(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    setVehicleMake(data.vehicleMake)
                    setVehicleModel(data.vehicleModel)
                    setColour(data.vehicleColour)
                    setSuccessfulLookupVrm(vrm)
                    setErrorMessage(null)
                }
                setLoadingVehicleLookup(false)
            },
            () => {
                setErrorMessage("Unable to locate vehicle details. Please check the VRM and try again.")
                setLoadingVehicleLookup(false)
            },
            vrm,
            organisationId, token
        )
    }

    const submit = () => {
        setIsLoading(true)
        if (isNew) {
            Api.addDisallowedVrm(
                data => {
                    if (data.isError) {
                        setErrorMessage(data.errorMessage)
                    } else {
                        setIsInEdit(false)
                        setDisallowedVrm(data)
                        history.push(returnUrl)
                    }
                    setIsLoading(false)
                },
                error => {
                    console.log(error)
                    setIsLoading(false)
                    setErrorMessage(error.errorMessage)                    
                },
                vrm, vehicleMake, vehicleModel, colour,
                driverName, driverMobileNumber, driverEmailAddress,
                !stringHelpers.isNullOrEmpty(startDate) ? startDate : null, 
                !stringHelpers.isNullOrEmpty(endDate) ? endDate : null,
                !stringHelpers.isNullOrEmpty(site?.id) ? site.id : null, 
                !stringHelpers.isNullOrEmpty(formClientId) ? formClientId : null, 
                reason, true,
                organisationId, token
            )
        } else {
            Api.editDisallowedVrm(
                data => {
                    if (data.isError) {
                        setErrorMessage(data.errorMessage)
                    } else {
                        setDisallowedVrm(data)
                        setIsInEdit(false)
                    }
                    setIsLoading(false)
                },
                error => {
                    console.log(error)
                    setIsLoading(false)
                    setErrorMessage(error.errorMessage)
                },
                disallowedVrmId,
                vrm, vehicleMake, vehicleModel, colour,
                driverName, driverMobileNumber, driverEmailAddress,
                startDate, endDate,
                !stringHelpers.isNullOrEmpty(site?.id) ? site.id : null, !stringHelpers.isNullOrEmpty(formClientId) ? formClientId : null, reason, true,
                organisationId, token
            )

        }
    }

    useEffect(() => {
        getSites()
        getClients()
        if (isNew) {
            setIsInEdit(true)
        } else {
            setIsLoading(true)
            Api.getDisallowedVrm(
                data => {
                    setDisallowedVrm(data)
                    setIsLoading(false)
                },
                error => {
                    setIsLoading(false)
                    console.log(error)
                },
                disallowedVrmId, organisationId, token
            )
        }
    }, [])

    useEffect(() => {
        if (disallowedVrm) {
            const site = sites?.find(x => x.id === disallowedVrm.siteId)

            setVrm(disallowedVrm.vrm);
            setVehicleMake(disallowedVrm.vehicleMake);
            setVehicleModel(disallowedVrm.vehicleModel);
            setColour(disallowedVrm.vehicleColour);
            setSite(site);
            setFormClientId(disallowedVrm.clientId)
            setDriverName(disallowedVrm.driverName);
            setDriverMobileNumber(disallowedVrm.driverMobileNumber);
            setStartDate(disallowedVrm.startDate);

            setEndDate(disallowedVrm.endDate);
            setReason(disallowedVrm.notes);

            if (stringHelpers.isNullOrEmpty(disallowedVrm.siteName) && stringHelpers.isNullOrEmpty(disallowedVrm.clientName)) {
                setTabActiveKey("global")
            } else if (!stringHelpers.isNullOrEmpty(disallowedVrm.clientName)) {
                setTabActiveKey("client")
            }
            else if (!stringHelpers.isNullOrEmpty(disallowedVrm.siteName)) {
                setTabActiveKey("site")
            }
        }
    }, [disallowedVrm, isInEdit])

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    {
                        !isNew && disallowedVrm &&
                        <div className="card mb-3">
                            <div className="card-header">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <h5 className="mb-0 d-flex align-items-center">Disallowed VRM - <p className="small-number-plate ml-2 mb-0">{ disallowedVrm.vrm }</p></h5>
                                    </div>
                                    <Link className="btn btn-falcon-default btn-sm mr-3 py-1" type="button" to={ returnUrl }><i className="fas fa-reply"></i> Back</Link>
                                    {
                                        (
                                            roleUtilities.isOrganisationAdminOrManager(user, organisationId) ||
                                            roleUtilities.isClientManager(user, organisationId) ||
                                            (
                                                roleUtilities.isClient(user, organisationId) &&
                                                !stringHelpers.isNullOrEmpty(disallowedVrm.endDate) && isDateTimeElapsed(disallowedVrm.endDate)
                                            )
                                        ) &&
                                        <button className="btn btn-falcon-default btn-sm dropdown-toggle py-2 mr-3 dropdown-caret-none" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i className="fas fa-ellipsis-h"></i></button>
                                    }
                                    <div className="dropdown-menu dropdown-menu-right" x-placement="bottom-start">
                                        <button onClick={() => setShowDeleteModal(true)} className="dropdown-item text-danger">
                                            <i className="fas fa-times"></i> Delete Disallowed VRM</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    }
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0">
                                        { isNew ? <>{ addNewFormTitle }</> : <>Details</> }
                                    </h5>
                                </div>
                                {
                                    !isNew && !roleUtilities.isThirdPartyProcessor(user, organisationId) && !roleUtilities.isThirdPartyManager(user, organisationId) && !roleUtilities.isOrganisationProcessor(user, organisationId) &&
                                    <div className="col-auto">
                                        <button type="button" className="btn btn-primary btn-sm ml-2" onClick={ () => setIsInEdit(!isInEdit) }>
                                            <i className="fas fa-edit"></i> Edit
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                        {
                            isLoading 
                            ? <Loader />
                            : isInEdit
                                ? <>
                                    <div className="card-body bg-light border-top details-container">
                                        <h6 className="mb-3 fs-1">Vehicle Details</h6>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">VRM<span className="req"></span></p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className='d-flex align-items-center'>
                                                    <div className="form-group mb-1">
                                                        <input disabled={ loadingVehicleLookup } className="form-control mb-0 small-number-plate" autoFocus={ true } type="text" value={ vrm } onChange={ (e) => setVrm(e.target.value.toUpperCase()) } />
                                                    </div>
                                                    <button
                                                        onClick={ () => vehicleLookup() }
                                                        disabled={
                                                            stringHelpers.isNullOrEmpty(vrm) ||
                                                            !stringHelpers.isValidVrm(vrm) ||
                                                            (
                                                                !stringHelpers.isNullOrEmpty(vrm) && !stringHelpers.isNullOrEmpty(successfulLookupVrm) && vrm === successfulLookupVrm
                                                            ) ||
                                                            loadingVehicleLookup
                                                        }
                                                        className='btn btn-falcon-default btn-sm ml-3 mb-1'
                                                    >
                                                        <div className='d-flex align-items-center'>
                                                            {
                                                                loadingVehicleLookup
                                                                    ? <span className="tiny-loader mr-2"><Loader /></span>
                                                                    : <i className='fas fa-search mr-1'></i>
                                                            }
                                                            Vehicle Lookup
                                                        </div>
                                                    </button>
                                                </div>
                                                { !stringHelpers.isNullOrEmpty(vrm) && !stringHelpers.isValidVrm(vrm) && <small className='text-danger'>Invalid VRM format</small> }
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Vehicle Make</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">
                                                <div className="form-group mb-1">
                                                    <input disabled={ loadingVehicleLookup } className="form-control mb-0" type="text" value={ vehicleMake } onChange={ (e) => setVehicleMake(e.target.value) } />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Vehicle Model</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">
                                                <div className="form-group mb-1">
                                                    <input disabled={ loadingVehicleLookup } className="form-control mb-0" type="text" value={ vehicleModel } onChange={ (e) => setVehicleModel(e.target.value) } />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Colour</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">
                                                <div className="form-group mb-1">
                                                    <input disabled={ loadingVehicleLookup } className="form-control mb-0" type="text" value={ colour } onChange={ (e) => setColour(e.target.value) } />
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="border-dashed border-bottom-0"></hr>
                                        <h6 className="mb-3 fs-1">Driver Details</h6>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Name</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={ driverName } onChange={ (e) => setDriverName(e.target.value) } />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Mobile Number</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={ driverMobileNumber } onChange={ (e) => setDriverMobileNumber(e.target.value) } />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Email Address</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-1">
                                                    <input className="form-control mb-0" type="text" value={ driverEmailAddress } onChange={ (e) => setDriverEmailAddress(e.target.value) } />
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="border-dashed border-bottom-0"></hr>

                                        {!arrayUtilities.isNullOrEmpty(sites) && <ClientSiteTabbed
                                            onTabChange={ e => handleTabChange(e) }
                                            clients={ clients }
                                            client={ formClientId }
                                            setClient={ setFormClientId }
                                            sites={ sites }
                                            site={ site }
                                            setSite={ setSite }
                                            isClientOrClientManager={ isClientOrClientManager }
                                            activeKey={tabActiveKey}
                                            assignedSiteIds={clientAssignedSiteIds}
                                            hideSiteSubdivisions
                                        />}
                                        <hr className="border-dashed border-bottom-0"></hr>
                                        <h6 className="mb-3 fs-1">Date Details</h6>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Start Date</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="datetime-local" value={ toInputFieldDateTimeString(startDate) } onChange={ (e) => setStartDate(e.target.value) } />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">End Date</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="datetime-local" value={ toInputFieldDateTimeString(endDate) } onChange={ (e) => setEndDate(e.target.value) } />
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="border-dashed border-bottom-0"></hr>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mt-1 mb-1">Notes</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-1">
                                                    <textarea className="form-control mb-0" rows={ 4 } value={ reason } onChange={ (e) => setReason(e.target.value) } />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2"
                                                        onClick={ () => {
                                                            if (isNew) {
                                                                history.push(returnUrl)
                                                            } else {
                                                                setIsInEdit(false)
                                                            }
                                                        } }>
                                                        <i className="fas fa-times mr-1"></i>
                                                        Cancel
                                                    </button>
                                                    <button disabled={ stringHelpers.isNullOrEmpty(vrm) } type="button" className="btn btn-success btn-sm ml-2" onClick={ () => submit() }>
                                                        <i className="fas fa-check mr-1"></i>
                                                        Confirm
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                                : disallowedVrm && <DisallowedVrmDisplay allowedVrm={ disallowedVrm } />
                        }
                       
                    </div>
                </div>
            </div>
            {
                !stringHelpers.isNullOrEmpty(errorMessage) &&
                <ErrorModal
                    message={ errorMessage }
                    onHide={ () => setErrorMessage(null) }
                />
            }
            {
                showDeleteModal &&
                <Modal show onHide={ () => setShowDeleteModal(false) }>
                    <Modal.Header className='d-flex justify-content-between align-items-start'>
                        <Modal.Title className="modal-title"><h5 className="modal-title">Are you sure you want to delete this Disallowed VRM?</h5></Modal.Title>
                        <button onClick={ () => setShowDeleteModal(false) } type="button" className="close" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </Modal.Header>
                    <Modal.Footer>
                        <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ () => setShowDeleteModal(false) }>Cancel</button>
                        <button type="button" className="btn btn-danger btn-sm ml-2" onClick={ () => {}}>Delete</button>
                    </Modal.Footer>
                </Modal>
            }
        </div>
    )
}